// TODO: Add more error checking.
export var hslRegex = /hsl\((\d{1,3}),\s?(\d{1,3})%,\s?(\d{1,3})%\)/i;
export function isHSLValue(hsl) {
    return Boolean(hsl === null || hsl === void 0 ? void 0 : hsl.match(hslRegex));
}
export function setHSLLighness(hsl, lightness) {
    var _a;
    if (hsl && lightness && isHSLValue(hsl)) {
        var _b = (_a = hsl.match(hslRegex)) === null || _a === void 0 ? void 0 : _a.map(function (part) { return Number(part.trim()); }), h = _b[1], s = _b[2];
        return "hsl(" + h + ", " + s + "%, " + lightness.toString().trim() + "%)";
    }
    // eslint-disable-next-line no-console
    console.error("setHSLLighness('" + hsl + "', " + lightness + "): Unable to generate new HSL Value.");
    return hsl;
}
export function decreaseHSLLightnessBy(hsl, percent) {
    var _a;
    if (hsl && percent && isHSLValue(hsl)) {
        var _b = (_a = hsl.match(hslRegex)) === null || _a === void 0 ? void 0 : _a.map(function (part) { return Number(part.trim()); }), h = _b[1], s = _b[2], l = _b[3];
        return "hsl(" + h + ", " + s + "%, " + (l - Number(percent.toString().trim())) + "%)";
    }
    // eslint-disable-next-line no-console
    console.error("decreaseHSLLightnessBy('" + hsl + "', " + percent + "): Unable to generate new HSL Value.");
    return hsl;
}
//# sourceMappingURL=color.utilities.js.map